import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-intern',
  imports: [],
  templateUrl: './intern.component.html',
  styleUrl: './intern.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InternComponent {

}
